import React from 'react';
import { EmailOptInAgreement } from './EmailOptInAgreement';
import { isCountryISOCodeOptIn } from '../utils/SignupCountryUtils';
import { useSignupPageContext } from '../../../pages/SignupContext';

interface EmailAgreementProps {
  optInEmailAgreement: boolean;
  optOutEmailAgreement: boolean | undefined;
  setOptInEmailAgreement: (optIn: boolean) => void;
  setOptOutEmailAgreement: (optOut: boolean) => void;
  countryIsoCode: string;
}

export const EmailAgreement = ({
  optInEmailAgreement,
  setOptInEmailAgreement,
  countryIsoCode,
}: EmailAgreementProps) => {
  const { renderingOptions } = useSignupPageContext();
  if (renderingOptions.showEmailAgreementCheckbox) {
    return (
      <EmailOptInAgreement
        optInEmailAgreement={optInEmailAgreement}
        optInAgreementOnChangeHandler={(optIn: boolean) => setOptInEmailAgreement(!optIn)}
      />
    );
  }
  if (countryIsoCode && isCountryISOCodeOptIn(countryIsoCode)) {
    return (
      <EmailOptInAgreement
        optInEmailAgreement={optInEmailAgreement}
        optInAgreementOnChangeHandler={(optIn: boolean) => setOptInEmailAgreement(!optIn)}
      />
    );
  }
  return null;
};
